var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHoverSubmitFinal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#E42125"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 8.375H11V7.5H14.5V8.375ZM11 11H14.5V11.875H11V11ZM11.8955 17.125L12.7705 18H5.75V4H16.25V12.7705L15.375 13.6455V4.875H6.625V17.125H11.8955ZM10.4326 6.93262L8.8125 8.55273L7.62988 7.37012L8.24512 6.75488L8.8125 7.32227L9.81738 6.31738L10.4326 6.93262ZM10.4326 10.4326L8.8125 12.0527L7.62988 10.8701L8.24512 10.2549L8.8125 10.8223L9.81738 9.81738L10.4326 10.4326ZM8.8125 14.3223L9.81738 13.3174L10.4326 13.9326L8.8125 15.5527L7.62988 14.3701L8.24512 13.7549L8.8125 14.3223ZM17.8701 13.9326L14.0625 17.7471L12.2236 15.9014L12.8389 15.2861L14.0625 16.5029L17.2549 13.3174L17.8701 13.9326Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoverSubmitFinal);
export default __webpack_public_path__ + "static/media/hoverSubmitFinal.77383979494c86f28e9ed66f710d0caa.svg";
export { ForwardRef as ReactComponent };